import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import '../customerMaster/customerMaster.scss';
import SaveSuccessModel from '../../components/common/SaveSuccessModel';
import ErrorMessage from '../../components/common/ErrorMessage';
import DataFilter from '../../utils/DataFilter';
import DataSearch from '../../utils/DataSearch';
import FetchData, { DeleteEntry, GetList } from '../../providers/dataProvider';
import { CheckNull } from '../../utils/Validate';
import { useRolePermission } from "../../hooks/useRolePermission";
import DeleteModal from '../../components/common/DeleteModal';
import CustomerMasterGrid from '../../components/customerMaster/CustomerMasterGrid';
import { SearchComponent } from '../../components/common/SearchComponent';
import AdvancedFilterDropdown from '../../components/common/AdvancedFilterDropdown';
import { PlaceHolder } from '../../constants/PlaceHolderConstants';
import { getStorageData } from '../../utils/Validate';

const CustomerMasterList = () => {
    const navigate = useNavigate();
    const [customerData, setCustomerData] = useState([]);
    const [filteredResults, setfilterResult] = useState([]);
    const [status, setStatus] = useState(null);
    const [country, setCountry] = useState(null);
    const [clrFilter, setClrFilter] = useState(false);
    const [search, setSearch] = useState("");
    const [deleteShow, setDeleteShow] = useState({ show: false, item: "", title: '', textCode: '', text: '', loading: false });
    const [createMsg, setCreateMsg] = useState(null);
    const [successShow, setSuccessShow] = useState(false)
    const [salesEng, setSalesEng] = useState(null);
    const [distributors, setDistributors] = useState(null);
    const [refreshData, setRefreshData] = useState([]);
    const [customerTypeDrp, setCustomerTypeDrp] = useState([]);
    const [customerTypeName, setCustomerTypeName] = useState(null);
    const { menuRights } = useRolePermission("Customer Master");

    const baseColumns = [
        {
            heading: 'Customer Name',
            value: 'customerName',
            sortable: true,
        },
        {
            heading: 'Email',
            value: 'email',
            sortable: true,
        },
        {
            heading: 'Distributor',
            value: 'distributorName',
            sortable: true,
        },
        {
            heading: 'Country',
            value: 'countryName',
            sortable: true,
        },
        {
            heading: 'Status',
            value: 'status',
            sortable: true,
        },

    ]

    const [CustomerFilter, setCustomerFilter] = useState({
        distributors: '',
        salesEng: '',
        distributorName: '',
        salesEngineerName: '',
        country: '',
        countryName: '',
        status: '',
        customerTypeName: ''
    });

    //  search
    const [refreshSearch, setRefreshSearch] = useState(false);
    const [errorShow, setErrorShow] = useState({ show: false, errorMessage: "" });

    const handleChange = (e, index) => {
        const activeData = document.getElementById(index).checked
        if (activeData == false) {
            setSelected(oldData => [...oldData, e.target.value])
        } else {
            setSelected(selected.filter(values => values !== e.target.value))
        }
    };

    const { data, loading } = FetchData("Customer");
    const { data: countrydata } = FetchData("country");
    const { data: distributor } = FetchData("distributor");
    const { data: salesEngineer } = FetchData("userprofile");
    const { data: customerStatus } = FetchData("customerStatus");
    const { data: customertype } = FetchData("customertype");

    useEffect(() => {
        let filterdata = customerData?.map((filterItem, index) => {
            let countryName = "";
            let customStatus = "";
            let distributorName = "";
            let salesEngName = "";

            let customerTypeIds = filterItem?.type;
            let customerTypeNames = [];
            var customerTypeValue = [];

            var countryValue = countrydata.filter(function (item) {
                return item.id === filterItem.countryId;
            });
            if (countryValue) countryName = countryValue[0]?.name
            filterItem.countryName = countryName


            var customerStatusValue = customerStatus.filter(function (item) {
                return item.id === filterItem.statusId
            });
            if (customerStatusValue) customStatus = customerStatusValue[0]?.status
            filterItem.status = customStatus

            var distributorValue = distributor.filter(function (item) {
                return item.id === filterItem.distributorId
            });
            if (distributorValue) distributorName = distributorValue[0]?.distributorName
            filterItem.distributorName = distributorName

            var salesEngValue = salesEngineer.filter(function (item) {
                return item.identityId === filterItem.assignedEngineerId
            });
            if (salesEngValue)
                salesEngName = salesEngValue[0]?.firstName + " " + salesEngValue[0]?.lastName;
            filterItem.salesEngineerName = salesEngName;

            if (typeof customerTypeIds === 'string') {
                customerTypeValue = customertype.filter(function (item) {
                    return customerTypeIds.split(',').includes(item.id.toString())
                });
            } else if (typeof customerTypeIds === 'number') {
                customerTypeValue = customertype?.filter(function (item) {
                    return item.id === customerTypeIds
                })
            }
            customerTypeValue?.forEach(function (item) {
                customerTypeNames.push(item.type)
            });
            filterItem.customerTypeName = customerTypeNames.join(", ");
            filterItem['view'] = menuRights?.canView === true ? 'VIEW' : 'NOT-VIEW'
            return filterItem
        })
        filterdata = [...filterdata].sort(function (a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt)
        });
        if (search != '') ApplySearch()
        else setfilterResult(filterdata)
    }, [customerData, countrydata, customerStatus, menuRights, salesEngineer])

    useEffect(() => { if (data) { setCustomerData(data) } }, [data])

    const formatCustomerType = (list) => {
        var te = list?.map((data, index) => ({
            label: data?.type,
            value: data?.id
        }));
        return te;
    };

    useEffect(() => {
        if (customertype) {
            const list = formatCustomerType(customertype);
            setCustomerTypeDrp(list)
        }
    }, [customertype])

    //Status
    const statusdrp = [
        { value: "1", label: "Active" },
        { value: "2", label: "Inactive" },
        { value: "3", label: "Blacklisted" },
        { value: "4", label: "Order Blocked" },
        { value: "5", label: "Delivery Blocked" }
    ]


    //Filter
    const handleLabelFilterChange = (selectedOption, params) => {
        if (params === "status") setStatus(selectedOption)
        if (params === "countryName") setCountry(selectedOption)
        setCustomerFilter({ ...CustomerFilter, [params]: selectedOption?.label });
    };

    const handleFilterChange = (selectedOption, params) => {
        if (params === "distributorId") setDistributors(selectedOption)
        if (params === "assignedEngineerId") setSalesEng(selectedOption)
        setCustomerFilter({ ...CustomerFilter, [params]: selectedOption?.value });
    }

    const handleTypeFilterChange = (selectedOption) => {
        setCustomerTypeName(selectedOption)
        setCustomerFilter({ ...CustomerFilter, customerTypeName: selectedOption?.label })
    };

    const [selected, setSelected] = useState([])

    useEffect(() => {
        if (refreshSearch === true || search == '') ApplySearch();
    }, [search])

    const handleEdit = (item) => {
        if (item) navigate('/add-new-customer', {
            state: {
                row: item,
                id: item?.id,
                canAdd: menuRights?.canAdd,
                canEdit: menuRights?.canEdit
            }
        })
    }

    //successShow
    const SuccessDoneClick = () => {
        setSuccessShow(false);
        GetList("Customer", "", setRefreshData)
    }

    const handleDelete = (item) => {
        setDeleteShow({
            show: true,
            item: item,
            title: 'Do You want to delete this Customer?',
            textCode: 'Customer Name',
            text: item?.customerName,
            loading: false
        })
    }

    const handleCancelDelete = () => {
        setDeleteShow({ show: false, item: "", title: '', textCode: '', text: '', loading: false })
    }

    const ErrorDoneClick = () => {
        setErrorShow({ show: false, errorMessage: "" })
        setCreateMsg(null);
    }

    const handleConfirmDelete = (item) => {
        setDeleteShow({ ...deleteShow, loading: true })
        DeleteEntry("Customer", item, setCreateMsg, "Customer deleted successfully", "Failed to delete customer")
    }

    useEffect(() => {
        if (createMsg?.successData === "Successful") {
            if (CheckNull(createMsg?.message) !== "") {
                setDeleteShow({ show: false, item: "", title: '', textCode: '', text: '', loading: false })
                setSuccessShow(true)
            }
        } else {
            if (CheckNull(createMsg?.message) !== "") {
                setDeleteShow({ show: false, item: "", title: '', textCode: '', text: '', loading: false })
                setErrorShow({ show: true, errorMessage: createMsg.message })
                setSuccessShow(false)
            }
        }
    }, [createMsg]);

    const ClearFilter = () => {
        setCustomerFilter({
            distributors: '',
            salesEng: '',
            distributorName: '',
            salesEngineerName: '',
            country: '',
            countryName: '',
            status: '',
            customerTypeName: []
        })
        setDistributors(null);
        setSalesEng(null);
        setCountry(null);
        setStatus(null);
        setCustomerTypeName(null)
        setClrFilter(true);
    }

    const RefreshList = () => {
        window.location.reload();
    }

    useEffect(() => {
        if (clrFilter === true) {
            ApplyFilter();
        }
    }, [clrFilter]);

    const ApplyFilter = () => {
        let filterResult = DataFilter(customerData, CustomerFilter);
        filterResult = DataSearch(filterResult, search, baseColumns.filter(({ value }) => !selected.includes(value)));
        filterResult = [...filterResult].sort(function (a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt)
        });
        setfilterResult(filterResult)
        setClrFilter(false);
    }

    const ApplySearch = () => {
        let SearchResult = [];
        SearchResult = DataSearch(customerData, search, baseColumns.filter(({ value }) => !value.includes("status")));
        SearchResult = DataFilter(SearchResult, CustomerFilter);
        SearchResult = [...SearchResult].sort(function (a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt)
        });
        setfilterResult(SearchResult)
        setRefreshSearch(false);
    }

    const handleKeyPress = (event) => { if (event.key === "Enter") { ApplySearch() } };

    const handleView = (item) => {
        menuRights?.canView && navigate('/view-customer', {
            state: item,
            canView: menuRights?.canView
        })
    };

    const removeSearch = () => { setSearch(""); setRefreshSearch(true) };
    const addNew = () => { navigate('/add-new-customer', { state: { canAdd: menuRights?.canAdd, canEdit: menuRights?.canEdit } }) }
    const hasActiveFilters = Boolean(
        distributors?.value ||
        salesEng?.value ||
        country?.value ||
        status?.value ||
        customerTypeName?.value
    );

    useEffect(() => { if (refreshData?.message === "success") { setCustomerData(refreshData?.data) } }, [refreshData]);

    return (
        <><section className="customers-list-sec" id="customersList">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0 p-1">
                        <div className="card">
                            <div className="card-body">
                                <div className="row search-area-row">
                                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-4 col-sm-12 col-xs-12 my-auto p-0">
                                        <div>
                                            <p>{filteredResults?.length} Results Found</p>
                                        </div>
                                    </div>

                                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-12 my-auto p-0">
                                        <SearchComponent
                                            filteredResults={filteredResults}
                                            search={search}
                                            handleKeyDown={handleKeyPress}
                                            setSearch={setSearch}
                                            removeSearch={removeSearch}
                                            ApplySearch={ApplySearch}
                                            RefreshList={RefreshList}
                                            baseColumns={baseColumns}
                                            selected={selected}
                                            handleChange={handleChange}
                                            data={data}
                                            addNew={addNew} 
                                            menuRights={menuRights}
                                            placeholder="Search by Customer"
                                            hasActiveFilters={hasActiveFilters}
                                            filterContent={(closeFilter) => (
                                                <AdvancedFilterDropdown
                                                    ApplyFilter={ApplyFilter}
                                                    ClearFilter={ClearFilter}
                                                    onCloseFilter={closeFilter}
                                                     startWithFirstOnly
                                                    fields={[
                                                        {
                                                            value: "distributorName",
                                                            label: "Distributor",
                                                            placeholder: PlaceHolder.SELECT_DISTRIBUTOR,
                                                            pageName: "customerList",
                                                            dpDownName: "distributor",
                                                            data: distributor,
                                                            valueObject: distributors,
                                                            valueId: CustomerFilter?.distributorName,
                                                            setState: setDistributors,
                                                            checkLabel: true,
                                                            hidden: getStorageData()?.userType === 2,
                                                            onChange: (e) => {
                                                                setDistributors(e);
                                                                setCustomerFilter({
                                                                    ...CustomerFilter,
                                                                    distributorName: e?.label,
                                                                });
                                                            },
                                                        },
                                                        {
                                                            value: "salesEngineerName",
                                                            label: "Sales Engineer",
                                                            placeholder: PlaceHolder.SELECT_SALES_ENGINEER,
                                                            pageName: "customerList",
                                                            dpDownName: "assignedTo",
                                                            data: salesEngineer,
                                                            valueObject: salesEng,
                                                            valueId: CustomerFilter?.salesEngineerName,
                                                            setState: setSalesEng,
                                                            checkLabel: true,
                                                            onChange: (e) => {
                                                                setSalesEng(e);
                                                                setCustomerFilter({
                                                                    ...CustomerFilter,
                                                                    salesEngineerName: e?.label,
                                                                });
                                                            },
                                                        },
                                                        {
                                                            value: "customerTypeName",
                                                            label: "Customer Type",
                                                            placeholder: "All",
                                                            type: "select",
                                                            options: customerTypeDrp,
                                                            valueObject: customerTypeName,
                                                            onChange: handleTypeFilterChange,
                                                        },
                                                        {
                                                            value: "status",
                                                            label: "Customer Status",
                                                            placeholder: PlaceHolder.SELECT_STATUS,
                                                            pageName: "customerList",
                                                            dpDownName: "customerStatus",
                                                            data: customerStatus,
                                                            valueObject: status,
                                                            valueId: CustomerFilter?.status,
                                                            setState: setStatus,
                                                            checkLabel: true,
                                                            onChange: (e) => handleLabelFilterChange(e, "status"),
                                                        },
                                                        {
                                                            value: "countryName",
                                                            label: "Country",
                                                            placeholder: PlaceHolder.SELECT_COUNTRY,
                                                            pageName: "customerList",
                                                            dpDownName: "country",
                                                            data: countrydata,
                                                            valueObject: country,
                                                            valueId: CustomerFilter?.countryName,
                                                            setState: setCountry,
                                                            checkLabel: true,
                                                            onChange: (e) => handleLabelFilterChange(e, "countryName"),
                                                        },
                                                    ]}
                                                />
                                            )} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <CustomerMasterGrid
                    filteredResults={filteredResults}
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                    handleView={handleView}
                    loading={loading}
                    menuRights={menuRights}
                    moduleName='customer' />
            </div>
        </section>
            {/*  <!-- deleteModal --> */}
            <DeleteModal deleteShow={deleteShow} handleCancelDelete={handleCancelDelete} handleConfirmDelete={handleConfirmDelete} />
            <ErrorMessage Show={errorShow?.show} errorMessage={errorShow?.errorMessage} ErrorDoneClick={ErrorDoneClick} />
            <SaveSuccessModel show={successShow} createMsg={createMsg} setShow={setSuccessShow} SuccessDoneClick={SuccessDoneClick} />
        </>
    )
}

export default CustomerMasterList
